"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIDashboardPage = _interopRequireDefault(require("UIComponents/page/UIDashboardPage"));

var _default = function _default(props) {
  return _react.default.createElement(_UIDashboardPage.default, (0, _extends2.default)({}, props, {
    bodyClassName: (0, _classnames.default)('dashboard-page', props.bodyClassName)
  }));
};

exports.default = _default;
module.exports = exports.default;